// Local translations
export const T = {
  en_GB: {
    noRequestTitle: "Waiting for a signature request",
    noRequestDescription:
      "No signature request has been created yet. Create one below, or move the process back one step to keep editing.",
    revert: "Move back one step",
    requestTitle: "Signature request created",
    requestDescription:
      "The client can sign from the link below. Delete the request to move the process back a step.",
    deleteRequest: "Delete signature request",
    created: (date: string) => `Created ${date}`,
    eidSignature: "eID signature",
    simpleSignature: "Simple signature",
    statusPending: "Pending",
    statusSigning: "In progress",
  },
  nb_NO: {
    noRequestTitle: "Venter på signeringsforespørsel",
    noRequestDescription:
      "Ingen signeringsforespørsel er opprettet ennå. Opprett en nedenfor, eller flytt prosessen ett trinn tilbake for å fortsette redigeringen.",
    revert: "Flytt ett trinn tilbake",
    requestTitle: "Signeringsforespørsel opprettet",
    requestDescription:
      "Kunden kan signere via lenken nedenfor. Slett forespørselen for å flytte prosessen ett trinn tilbake.",
    deleteRequest: "Slett signeringsforespørsel",
    created: (date: string) => `Opprettet ${date}`,
    eidSignature: "eID-signatur",
    simpleSignature: "Enkel signatur",
    statusPending: "Venter",
    statusSigning: "Pågår",
  },
} as const;
